import classNames from 'classnames';
import React from 'react';

import {FormattedCurrency} from '@udemy/react-merchandising-components';

import styles from '../total-price/total-price.module.less';

interface FullPriceSummaryCreditDetailsProps {
    couponDiscounts: number;
    creditsApplied: number;
    listPriceAmount: number;
}

export const FullPriceSummaryCreditDetails: React.FC<FullPriceSummaryCreditDetailsProps> = ({
    couponDiscounts,
    creditsApplied,
    listPriceAmount,
}) => {
    return (
        <div className={styles['credit-details-container']}>
            <div className={classNames(styles.item, 'ud-text-sm')}>
                <span className={styles['item-title']}>{gettext('Original price:')}</span>
                <FormattedCurrency value={listPriceAmount} />
            </div>
            {couponDiscounts > 0 && (
                <div className={classNames(styles.item, 'ud-text-sm')}>
                    <span className={styles['item-title']}>{gettext('Coupon discounts:')}</span>
                    {'-'}
                    <FormattedCurrency value={couponDiscounts} />
                </div>
            )}
            <div
                className={classNames(styles['credit-balance-content'], styles.item, 'ud-text-sm')}
            >
                <span className={styles['item-title']}>{gettext('Credits applied:')}</span>
                {'-'}
                <FormattedCurrency value={creditsApplied} />
            </div>
        </div>
    );
};
